import React, { useState } from 'react';
import dayjs from 'dayjs';
import { css } from 'aphrodite/no-important';
import { SegmentedButton } from '@trainline/depot-web';
import weekday from 'dayjs/plugin/weekday';
import { BinaryFilterButton } from '@trainline/depot-web';

import { getDayJsLocale } from '@contactcentre-web/localisation/dayjs';
import { LOCALE_CODES } from '@contactcentre-web/localisation/locales';

import CustomDateRange from './CustomDateRange';
import styles from './styles';

dayjs.extend(weekday);

interface Props {
  selectedWeekStartDate: string;
  selectWeekStartDate: (weekStartDate: string) => void;
}

const PeriodSelector = ({ selectedWeekStartDate, selectWeekStartDate }: Props) => {
  const [isCustomDateRange, setIsCustomDateRange] = useState(false);
  const [customDateRange, setCustomDateRange] = useState<string>('');
  const [currentSelectedDate, setCurrentSelectedDate] = useState<string>('');
  dayjs().locale({ ...getDayJsLocale(LOCALE_CODES.ENGLISH), weekStart: 1 }); // TODO: Create component hook that retrieves locale from the redux store

  const mostRecentMonday = dayjs().weekday(0);

  const weekStartDates = [
    mostRecentMonday.format('YYYY-MM-DD'),
    mostRecentMonday.subtract(1, 'weeks').format('YYYY-MM-DD'),
    mostRecentMonday.subtract(2, 'weeks').format('YYYY-MM-DD'),
    mostRecentMonday.subtract(3, 'weeks').format('YYYY-MM-DD'),
    mostRecentMonday.subtract(4, 'weeks').format('YYYY-MM-DD'),
  ];

  const getLabelForDate = (weekStartDate: string) =>
    `${dayjs(weekStartDate).format('D MMM')} - ${dayjs(weekStartDate)
      .add(6, 'days')
      .format('D MMM')}`;

  const onCustomDateRangeSet = (selectedDate?: string) => {
    if (!selectedDate) return;

    setCurrentSelectedDate(selectedDate);

    const selectedDateObject = dayjs(selectedDate);
    const startOfWeek = selectedDateObject.startOf('week');
    const endOfWeek = selectedDateObject.endOf('week');

    setIsCustomDateRange(true);
    selectWeekStartDate(startOfWeek.format('YYYY-MM-DD'));

    const formatted = `${startOfWeek.format('D MMM')} - ${endOfWeek.format('D MMM YYYY')}`;
    setCustomDateRange(formatted);
  };

  const onCustomDateRangeClear = () => {
    setIsCustomDateRange(false);
    setCurrentSelectedDate('');
    selectWeekStartDate(weekStartDates[0]);
  };

  const today = dayjs(new Date()).format('D MMM YYYY');
  const formattedCurrentSelectedDate = dayjs(currentSelectedDate).format('D MMM YYYY');

  return (
    <div className={css(styles.periodSelectorContainer)}>
      {!isCustomDateRange ? (
        <SegmentedButton
          className={css(styles.periodSelector)}
          type="standard"
          segments={weekStartDates.map((weekStartDate, index) => ({
            label: index === 0 ? 'Current week' : getLabelForDate(weekStartDate),
            value: weekStartDate,
            checked: selectedWeekStartDate === weekStartDate,
            onChange: () => selectWeekStartDate(weekStartDate),
          }))}
        />
      ) : (
        <div>
          <BinaryFilterButton
            label={customDateRange}
            onClear={onCustomDateRangeClear}
            selected
            hasMenu
          />
        </div>
      )}
      <CustomDateRange
        datePickerStartDate={currentSelectedDate ? formattedCurrentSelectedDate : today}
        onCustomDateRangeSet={onCustomDateRangeSet}
      />
    </div>
  );
};

export default PeriodSelector;
